import React from 'react';

import {
  FiInfo,
  FiCheckCircle,
  FiHelpCircle,
  FiFileText,
  FiLayers,
  FiClipboard,
  FiCalendar,
  FiShield,
  FiCpu,
  FiAlertTriangle,
} from 'react-icons/fi';

export default function SidebarInformationPanel() {
  const guidanceItems = [
    <>
      Complete all mandatory fields (
      <span className="text-red-500">*</span>
      ).
    </>,
    'Assign the correct category and location.',
    'Set compliance requirements based on the equipment type.',
    'Upload clear photos, manuals and certificates.',
    'Configure maintenance and PAT dates.',
    'Link incidents later if any issues arise.',
    'Keep information up to date for compliance and inspections.',
  ];

  const relatedRecords = [
    {
      icon: FiClipboard,
      title: 'Equipment Register',
      desc: 'Automatically added',
      iconColor: 'text-blue-700',
    },
    {
      icon: FiCalendar,
      title: 'Maintenance Schedule',
      desc: 'Based on frequency set',
      iconColor: 'text-blue-700',
    },
    {
      icon: FiShield,
      title: 'PAT Record',
      desc: 'If applicable',
      iconColor: 'text-blue-700',
    },
    {
      icon: FiCpu,
      title: 'IoT Sensor',
      desc: 'If configured',
      iconColor: 'text-blue-700',
    },
    {
      icon: FiAlertTriangle,
      title: 'Incident Link',
      desc: 'Link incidents if any issues arise',
      iconColor: 'text-red-500',
    },
  ];

  return (
    <div className="max-w-sm flex flex-col space-y-4 font-sans bg-slate-50/50 p-1">

      {/* =====================================================
          1. GUIDANCE SECTION
      ====================================================== */}
      <div className="bg-white rounded-xl border border-slate-100 p-5 shadow-sm">

        <div className="flex items-center space-x-2.5 mb-4">

          <FiInfo
            className="w-5 h-5 text-blue-600 bg-blue-50 rounded-full"
            strokeWidth={2}
          />

          <h2 className="text-base font-bold text-indigo-950">
            Guidance
          </h2>

        </div>

        <ul className="space-y-3">

          {guidanceItems.map((text, idx) => (
            <li
              key={idx}
              className="flex items-start space-x-3 text-sm text-slate-600 leading-relaxed"
            >

              <FiCheckCircle
                className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0"
                strokeWidth={2}
              />

              <span>
                {text}
              </span>

            </li>
          ))}

        </ul>

      </div>

      {/* =====================================================
          2. RELATED RECORDS SECTION
      ====================================================== */}
      <div className="bg-white rounded-xl border border-slate-100 p-5 shadow-sm">

        <div className="flex items-center space-x-2.5 mb-5">

          <div className="p-1.5 bg-blue-600 rounded-lg text-white">

            <FiLayers
              className="w-4 h-4"
              strokeWidth={2.5}
            />

          </div>

          <h2 className="text-base font-bold text-indigo-950">

            Related Records

            <span className="text-xs font-normal text-slate-400 font-mono ml-1">
              (created after saving)
            </span>

          </h2>

        </div>

        <div className="space-y-4">

          {relatedRecords.map((record, idx) => {

            const RecordIcon = record.icon;

            return (
              <div
                key={idx}
                className="flex items-start space-x-3.5"
              >

                <RecordIcon
                  className={`w-5 h-5 mt-0.5 shrink-0 ${record.iconColor}`}
                  strokeWidth={2}
                />

                <div className="flex flex-col">

                  <h4 className="text-sm font-semibold text-indigo-950 leading-tight">
                    {record.title}
                  </h4>

                  <p className="text-xs text-slate-500 mt-0.5">
                    {record.desc}
                  </p>

                </div>

              </div>
            );
          })}

        </div>

      </div>

      {/* =====================================================
          3. NEED HELP SECTION
      ====================================================== */}
      <div className="bg-white rounded-xl border border-slate-100 p-5 shadow-sm">

        <div className="flex items-center space-x-2.5 mb-3">

          <FiHelpCircle
            className="w-5 h-5 text-blue-600"
            strokeWidth={2}
          />

          <h2 className="text-base font-bold text-indigo-950">
            Need Help?
          </h2>

        </div>

        <p className="text-sm text-slate-600 leading-relaxed mb-4">
          For guidance on equipment categories, compliance requirements
          or maintenance schedules, view the Equipment SOP or contact
          your manager.
        </p>

        <button
          onClick={() => alert('Opening SOP Document...')}
          className="
            w-full
            inline-flex
            items-center
            justify-center
            px-4
            py-2.5
            text-sm
            font-semibold
            text-blue-700
            bg-white
            border
            border-blue-200
            rounded-lg
            hover:bg-blue-50/50
            transition-colors
            focus:outline-none
            focus:ring-2
            focus:ring-offset-2
            focus:ring-blue-500
          "
        >

          <FiFileText
            className="w-4 h-4 mr-2"
            strokeWidth={2}
          />

          View Equipment SOP

        </button>

      </div>

    </div>
  );
}